import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { queryExtendedBookings as queryExtendedBookingsApi } from '@wix/ambassador-bookings-reader-v2-extended-booking/http';
import {
  QueryExtendedBookingsRequest,
  SortOrder,
} from '@wix/ambassador-bookings-reader-v2-extended-booking/types';
import { QueryFilters } from '../types';
import {
  getQueryFiltersFromSettings,
  getQueryFiltresIntersection,
} from '../queryFilters/queryFilters';
import settingsParams from '../../../components/DailyAgenda/settingsParams';

export const queryExtendedBookings = async ({
  flowAPI: { settings, httpClient, controllerConfig },
  filters,
  cursor,
}: {
  filters?: QueryFilters;
  flowAPI: ControllerFlowAPI;
  cursor?: string;
}) => {
  if (controllerConfig.wixCodeApi.user.currentUser.loggedIn === false) {
    return { extendedBookings: [], pagingMetadata: {} };
  }
  const now = new Date();
  const { serviceIds, businessLocationIds, staffMemberIds } =
    getQueryFiltresIntersection(getQueryFiltersFromSettings(settings), filters);
  const timeSlotsBeforeLoadMore = settings.get(
    settingsParams.timeSlotsBeforeLoadMore,
  );
  const contactId = controllerConfig.wixCodeApi.user.currentUser.id;
  const query: QueryExtendedBookingsRequest['query'] = {
    sort: [
      {
        order: SortOrder.ASC,
        fieldName: 'startDate',
      },
    ],
    filter: {
      endDate: {
        $gt: now.toISOString(),
      },
      'bookedEntity.tags': {
        $hasSome: 'GROUP',
      },
      status: {
        $in: ['CONFIRMED', 'PENDING', 'WAITING_LIST'],
      },
      ...(contactId ? { 'contactDetails.contactId': contactId } : undefined),
      ...(serviceIds && serviceIds.length > 0
        ? { 'bookedEntity.item.slot.serviceId': { $in: serviceIds } }
        : undefined),
      ...(staffMemberIds && staffMemberIds.length > 0
        ? { 'bookedEntity.item.slot.resource.id': { $in: staffMemberIds } }
        : undefined),
      ...(businessLocationIds && businessLocationIds.length > 0
        ? { 'bookedEntity.item.slot.location.id': { $in: businessLocationIds } }
        : undefined),
    },
    cursorPaging: {
      limit: timeSlotsBeforeLoadMore,
      ...(cursor ? { cursor } : undefined),
    },
  };

  const response = await httpClient.request(
    queryExtendedBookingsApi({
      query,
    }),
  );

  return response.data;
};
